module.exports = __webpack_public_path__ + "img/japanese-2.04062c18.svg";